module.exports = __webpack_public_path__ + "static/media/TOA.db9fcc24.jpg";